import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  background: ${props => props.theme.colors.rojoBac};
  padding: 20px 20px 30px;
  color: #fff;

  h1 {
    margin-top: 0;
    font-size: 50px;
  }

  small {
    font-size: 28px;
    display: block;
  }
`

export default ({ children }) => {
  return <Container>{children}</Container>
}
